import React, { useState } from "react"

import { closeNavUser } from "../../scripts/loginMenus"

import axios from "../../http/axios"

import FacebookLogin from "react-facebook-login"
import GoogleLogin from "react-google-login"

import { AUTH_TOKEN_KEY } from "../../constants/constants"
import { useCurrentUser } from "../../components/CurrentUserContext"

import EyeIcon from "../../svg/opened-eye-icon.inline.svg"
import EyeIconClosed from "../../svg/closed-eye-icon.inline.svg"

import XButtonIcon from "../../svg/x-button.inline.svg"

import SideNavForgotPasswordSection from "../../sections/login_signup_side_navs/SideNavForgotPasswordSection"

import SideNavForgotPasswordCheckMailSection from "../../sections/login_signup_side_navs/SideNavForgotPasswordCheckMailSection"

import SideNavUserSignupSection from "../../sections/login_signup_side_navs/SideNavUserSignupSection"

import SideNavEmailVerificationSection from "../../sections/login_signup_side_navs/SideNavEmailVerificationSection"
import { useTranslation } from "react-i18next"

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
)

const UserSideNavSection = () => {
  const { fetchCurrentUser } = useCurrentUser()
  const { t } = useTranslation()
  const [accessErr, setAccessErr] = useState(false)

  //Toggle eye
  const [passwordShown, setPasswordShown] = useState(false)
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true)
  }

  const toggled = passwordShown ? "toggled" : ""

  //Forgot password
  const [passwordForgot, setPasswordForgot] = useState(false)
  const togglePasswordForgot = () => {
    setPasswordForgot(passwordForgot ? false : true)
  }

  //Become member
  const [becomeMember, setBecomeMember] = useState(false)
  const toggleBecomeMember = () => {
    setBecomeMember(becomeMember ? false : true)
  }

  //Check email
  const [checkEmail, setCheckEmail] = useState(false)
  const toggleCheckEmail = () => {
    setCheckEmail(checkEmail ? false : true)
  }

  //Application thanks
  const [appThanks, setAppThanks] = useState(false)
  const toggleAppThanks = () => {
    setAppThanks(appThanks ? false : true)
  }

  let forgot = passwordForgot && !checkEmail && !appThanks ? "block" : "none"
  let mail = checkEmail ? "block" : "none"
  let member =
    !passwordForgot && becomeMember && !checkEmail && !appThanks
      ? "block"
      : "none"
  let thanks = appThanks ? "block" : "none"

  let backToLogin =
    forgot === "none" &&
    mail === "none" &&
    member === "none" &&
    thanks === "none" &&
    !passwordForgot &&
    !becomeMember &&
    !checkEmail &&
    !appThanks
      ? "block"
      : "none"

  function okThanks() {
    toggleCheckEmail()
    togglePasswordForgot()
  }

  function onAppThanks() {
    toggleAppThanks()
    toggleBecomeMember()
  }

  const [formValues, setFormValues] = useState({ email: "", password: "" })

  const [emailTriggered, setEmailTriggered] = useState(false)
  const [emailNotValid, setEmailNotValid] = useState(false)

  const [passwordTriggered, setPasswordTriggered] = useState(false)
  const [passwordNotValid, setPasswordNotValid] = useState(false)

  const [incorrectData, setIncorrectData] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    const config = {
      headers: {
        scope: "user",
      },
    }
    setAccessErr(false)
    axios
      .post(
        "/auth/login",
        {
          email: formValues.email,
          password: formValues.password,
        },
        config
      )
      .then(res => {
        setLoginResult(res.data)
      })
      .catch(error => {
        if (error.response.status === 403) {
          setAccessErr(true)
          return
        }
        if (error.response.data === "Invalid email or password") {
          setIncorrectData(true)
        }
        if (error.response.data.errors?.Email != undefined) {
          setEmailTriggered(true)
        }
        if (error.response.data.errors?.Password != undefined) {
          setPasswordTriggered(true)
        }
      })
  }

  let emailLengthZero = emailTriggered ? "email-length-zero" : ""
  let emailIsNotValid = emailNotValid ? "email-not-valid" : ""

  let passwordLengthZero = passwordTriggered ? "password-length-zero" : ""
  let passwordIsNotValid = passwordNotValid ? "password-not-valid" : ""

  const [formValidation, setFormValidation] = useState({
    email: null,
    password: null,
    errors: {
      email: "",
      password: "",
    },
  })

  const handleInputChanges = e => {
    e.persist()
    const { name, value } = e.target
    let validationErrors = formValidation.errors
    setEmailTriggered(false)
    setPasswordTriggered(false)
    setIncorrectData(false)

    switch (name) {
      case "email":
        validationErrors.email = validEmailRegex.test(value)
          ? ""
          : "Invalid email"
        break
      case "password":
        validationErrors.password = value.length < 8 ? "Invalid password" : ""
        break
      default:
        break
    }

    setFormValidation({ errors, [name]: value })

    if (errors.email === "Invalid email") {
      setEmailNotValid(true)
    } else {
      setEmailNotValid(false)
    }

    if (errors.password === "Invalid password") {
      setPasswordNotValid(true)
    } else {
      setPasswordNotValid(false)
    }

    setFormValues(currValues => ({
      ...currValues,
      [e.target.name]: e.target.value,
    }))
  }

  const setLoginResult = token => {
    localStorage.setItem(AUTH_TOKEN_KEY, token)
    fetchCurrentUser()
    closeNavUser()
  }

  const sendToken = response => {
    axios
      .post("/auth/login/google", { idToken: response.tokenId })
      .then(res => {
        setLoginResult(res.data)
      })
  }

  const sendTokenFb = response => {
    axios
      .post("/auth/login/facebook", { accessToken: response.accessToken })
      .then(res => {
        setLoginResult(res.data)
      })
  }

  const [emailToPass, setEmailToPass] = useState()

  const processUserEmail = email => {
    setEmailToPass(email.config.data.replace(/{|}|"|:|email/g, ""))
  }

  const { errors } = formValidation
  return (
    <div id="side-nav-user" className="sidenav-user">
      <div
        className="side-nav-user-wrapper"
        id="side-nav-user-wrapper"
        style={{ display: backToLogin }}
      >
        <div className="side-nav-user-top ps-5">
          <div className="f-ac f-js f-1">
            <div className="sign-up-btn f-ac" onClick={closeNavUser}>
              <div className="x-button-wrapper f-ac f-jc curs-P">
                <XButtonIcon className="x-button" />
              </div>
              <div className="sign-up-text">{t("school.header.userLogin")}</div>
            </div>
          </div>
          <div className="f-ac f-je f-1 right-side">
            <div className="side-nav-user-right-item item-having-acc">
              {t("main.header.dontHaveAccount")}
            </div>
            <div
              className="side-nav-user-right-item item-sign-up closebtn icon_button"
              id="back"
              onClick={toggleBecomeMember}
            >
              {t("main.header.signUp")}
            </div>
          </div>
        </div>

        <div className="side-nav-user-info">
          {/* <App/> */}

          <form onSubmit={handleSubmit} noValidate>
            <div className="login-with-wrapper">
              <div className="form-field google-login">
                <div className="google-logo social-item"></div>

                <GoogleLogin
                  clientId="471557542326-t76d89ta3silnmulm38ok69cf9vflgae.apps.googleusercontent.com"
                  render={renderProps => (
                    <div
                      className="google-text social-item"
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled}
                    >
                      {t("main.header.logInGoogle")}
                    </div>
                  )}
                  onSuccess={sendToken}
                  cookiePolicy={"single_host_origin"}
                />
              </div>
              <div className="form-field facebook-login">
                <div className="facebook-logo social-item"></div>
                <FacebookLogin
                  scope="public_profile, email"
                  appId="1004871576975657"
                  callback={sendTokenFb}
                  textButton={t("main.header.logWithFacebook")}
                  render={renderProps => (
                    <button
                      className="facebook-text social-item"
                      onClick={renderProps.onClick}
                    >
                      {t("main.header.logWithFacebook")}
                    </button>
                  )}
                />
              </div>
            </div>
            <div className="form-field login-or">
              <div className="text-item-or">{t("main.header.or")}</div>
            </div>
            <div className="input-group special-group d-flex flex-column">
              <input
                className={`form-field ${emailIsNotValid} ${emailLengthZero}`}
                type="email"
                name="email"
                required
                placeholder={t("main.header.email")}
                value={formValues.email}
                onChange={handleInputChanges}
                noValidate
              />

              {/* <label>Email</label> */}
              {errors.email.length !== 0 && (
                <span className="error">{t("main.header.ivalidEmail")}</span>
              )}
              {errors.email.length === 0 && (
                <span className={`error email-validation ${emailLengthZero}`}>
                  {t("main.header.emailRequired")}
                </span>
              )}

              {accessErr && (
                <span className={`error`}>{t("main.accessDenied")}</span>
              )}
            </div>

            <div className="password-input-groups-wrapper">
              <div className="input-group special-group d-flex flex-column">
                <input
                  id="password"
                  className={`form-field ${passwordIsNotValid} ${passwordLengthZero}`}
                  type={passwordShown ? "text" : "password"}
                  name="password"
                  required
                  value={formValues.password}
                  onChange={handleInputChanges}
                  placeholder={t("main.header.password")}
                />
                {/* <label>{t("main.header.password")}</label> */}

                {errors.password.length > 0 && (
                  <span className="error">
                    {t("main.header.ivalidPassword")}
                  </span>
                )}

                {errors.password.length === 0 && (
                  <span
                    className={`error password-validation ${passwordLengthZero}`}
                  >
                    {t("main.header.passwordRequired")}
                  </span>
                )}

                {incorrectData && (
                  <span className={`error`}>
                    {t("main.header.incorrectLoginData")}
                  </span>
                )}
              </div>
              <EyeIcon
                className={`password-eye ${toggled}`}
                id="togglePassword"
                onClick={togglePasswordVisiblity}
              />
              <EyeIconClosed
                className={`password-eye crossed-eye-icon ${toggled}`}
                id="togglePassword"
                onClick={togglePasswordVisiblity}
              />
            </div>

            <button className="form-field login-button" type="submit">
              {t("main.header.logwithEmail")}
            </button>

            <div
              className="forgot-password form-field"
              id="fpass"
              onClick={togglePasswordForgot}
            >
              {t("main.header.forgotPassword")}
            </div>
          </form>
        </div>
      </div>
      {passwordForgot && !checkEmail && !appThanks && (
        <SideNavForgotPasswordSection
          backFunction={togglePasswordForgot}
          checkEmailFunction={toggleCheckEmail}
          passUserEmail={processUserEmail}
        />
      )}

      {checkEmail && (
        <SideNavForgotPasswordCheckMailSection
          backFunction3={okThanks}
          userEmailForPassReset={emailToPass}
        />
      )}

      {!passwordForgot && becomeMember && !checkEmail && !appThanks && (
        <SideNavUserSignupSection
          displayStyle2={member}
          backFunction2={toggleBecomeMember}
          thanksFunction={toggleAppThanks}
          passUserEmail={processUserEmail}
        />
      )}

      {appThanks && (
        <SideNavEmailVerificationSection
          displayStyle4={thanks}
          backFunction4={onAppThanks}
          userEmailForPassReset={emailToPass}
        />
      )}
    </div>
  )
}

export default UserSideNavSection
